import React from 'react';
import { Layout } from 'antd';
import { Link } from 'react-router-dom';

const { Footer } = Layout;

const AppFooter = () => {
  return (
    <Footer style={{ textAlign: 'center' }}>
      <div style={{ marginBottom: 8 }}>
        <Link to="/privacy-policy" style={{ margin: '0 12px' }}>
          Privacy Policy
        </Link>
        <Link to="/terms-conditions" style={{ margin: '0 12px' }}>
          Terms & Conditions
        </Link>
      </div>
      Yoga Refer ©{new Date().getFullYear()} Created by Greenwill Techs
    </Footer>
  );
};

export default AppFooter;